import moment from "moment";
import { ErrorMessage } from "PFComponents/error_message/error_message";
import React from "react";
import { useFormContext } from "react-hook-form";

import { CalendarForm } from "../../../../calendars.types";
import { INITIAL_END_TIME, INITIAL_START_TIME, WORKDAY_MINUTES } from "../../../../calendars.utils";
import css from "../../dates.module.scss";
import { DayToggleButton } from "../day_toggle_button";
import { TimeSection } from "../time_section";
import { extractErrorMessage } from "../utils";
import { WeekDayName } from "./week_day_name";

type WeekDayProps = {
  index: number;
};

export const WeekDay = ({ index }: WeekDayProps): JSX.Element => {
  const {
    setValue,
    watch,
    formState: { errors }
  } = useFormContext<CalendarForm>();
  const [from, to, duration] = watch([
    `nominalDays.${index}.startTime`,
    `nominalDays.${index}.endTime`,
    `nominalDays.${index}.workingMinutes`
  ]);

  const handleToggle = () => {
    setValue(`nominalDays.${index}.startTime`, from ? null : INITIAL_START_TIME);
    setValue(`nominalDays.${index}.endTime`, to ? null : INITIAL_END_TIME);
    setValue(`nominalDays.${index}.workingMinutes`, duration ? 0 : WORKDAY_MINUTES);
  };

  const errorMessage = extractErrorMessage(index, errors, "nominalDays");
  const isDisabled = !from && !to;

  return (
    <div className={css.dayContainer}>
      <div className={css.sheduleItem}>
        <WeekDayName dayName={moment.weekdays(true)[index]} isDisabled={isDisabled} />
        <DayToggleButton isDisabled={isDisabled} onToggle={handleToggle} />
        <TimeSection index={index} daysType="nominalDays" isDisabled={isDisabled} />
      </div>
      {errorMessage && <ErrorMessage message={errorMessage} />}
    </div>
  );
};
